import { UseAsyncStateOptions, useAsyncState } from '@vueuse/core';
import { computed, ref } from 'vue';

const uninitialized = Symbol('uninitialized');

export function useLazyAsyncState<Data, Shallow extends boolean = true>(
  promise: () => Promise<Data>,
  initialState: Data,
  options?: UseAsyncStateOptions<Shallow, Data>,
  name?: string
) {
  const opts = {
    immediate: false,
    ...options,
  };

  const hasErrored = ref(false);
  const hasStartedLoading = ref(opts.immediate);
  const ret = useAsyncState(promise, uninitialized as any, opts);

  const execute = () => {
    hasErrored.value = false;
    hasStartedLoading.value = true;
    return ret.execute().catch(error => {
      console.error('Error in lazy async state:', error);
      hasErrored.value = true;
      throw error;
    });
  };

  return {
    ...ret,
    execute,
    state: computed(() => {
      if (ret.state.value === uninitialized && !hasErrored.value) {
        if (!hasStartedLoading.value) {
          execute();
        }
        return initialState;
      }
      return ret.state.value === uninitialized ? initialState : ret.state.value;
    }),
  };
}